import {Fonts} from "@/constants/font";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import {Keys} from "@/constants/key";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import Text from "phaser3-rex-plugins/plugins/gameobjects/text/textbase/Text";
import {Tag} from "@/store/forum/types";
import {ForumUtils} from "@/utils/forum-utils";
import OnceCaller from "@/utils/once-caller";
import ForumStore from "@/store/forum";

export class ClickableTag extends Phaser.GameObjects.Container {

    closeBtn!: Phaser.GameObjects.Image;
    tagBg: Phaser.GameObjects.Sprite;
    tagLine!: BBCodeText;
    tag!: Tag;

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, tag:Tag, x:number, y:number,  tagCallback: (tag:Tag|undefined) => unknown) {
        super(scene);
        this.scene = scene;
        this.tag = tag;

        // let color = this.isChosen()? '#00ffff': '#16c0cb';
        let color = this.isChosen()? '#f7dc99': '#e9c25c';

        let tagStyle : Text.TextStyle= {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '13pt',
            align: 'center',
            wrap: {
                mode: 1,
                width: 420
            },
            underline: {
                color: color,
                thickness: 2,
                offset: 2
            }
        }

        let action = () => {
            if(this.isChosen()){
                tagCallback(undefined);
            } else {
                tagCallback(tag);
            }
        };
        // this.tagLine = new BBCodeText(scene, x, y, '[color='+color+'][u]' + '#' + ForumUtils.getTagName(tag) + '[/u][/color]', tagStyle).setScale(CU.S, CU.S);
        this.tagLine = new BBCodeText(scene, x, y, '[color='+color+']' + '#' + ForumUtils.getTagName(tag) + '[/color]', tagStyle).setScale(CU.S, CU.S);

        this.tagLine.setOrigin(0, 0.5);
        this.tagLine.setInteractive().on('pointerup', action);

        this.tagBg = SpriteUtils.addSprite(this.scene!, this.tagLine.x/CU.S-8/CU.S, y/CU.S, Keys.FRM_TAG_BG).setOrigin(0.5, 0.5);
        this.tagBg.setOrigin(0, 0.5);
        this.tagBg.setVisible(this.isChosen());
        this.tagBg.setScale((this.tagLine.width*CU.S + 40)/140, 0.9*CU.S);
        this.tagBg.setInteractive().on('pointerup', action);
        this.tagBg.alpha = 1;

        this.closeBtn = SpriteUtils.addSprite(this.scene!, this.tagLine.x/CU.S + this.tagLine.width + 14/CU.S, this.tagLine.y/CU.S, Keys.FRM_CLOSE).setOrigin(0.5, 0.5);
        this.closeBtn.setVisible(this.isChosen());
        this.closeBtn.setInteractive().on('pointerup', action);

        this.add([this.tagBg, this.tagLine, this.closeBtn]);
    }

    public getCloseX(): number {
        return this.isChosen()? this.closeBtn.x +10 : this.closeBtn.x - 15;
    }

    public isChosen(): boolean {
        return ForumStore.chosenTag == this.tag;
    }

}
